import { memo, ReactEventHandler, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentMerchantId } from './header-hooks'

const ICEBERG_WEBSITE_HOST = 'https://icebergfinance.ca'

interface HeaderProps {
  language: string
}

const Header = ({ language }: HeaderProps) => {
  const { t, i18n } = useTranslation()
  const [logoClasses, setLogoClasses] = useState('')
  const targetLanguage = t('common.targetLanguage')

  const currentMerchantId = useCurrentMerchantId()

  const contactUsText = language === 'en' ? 'contact-us' : 'nous-joindre'
  const needToHelpUrl =
    language === 'en'
      ? `${ICEBERG_WEBSITE_HOST}/${language}/${contactUsText}/`
      : `${ICEBERG_WEBSITE_HOST}/${contactUsText}/`

  const faqLink = () => {
    return `${ICEBERG_WEBSITE_HOST}/${language}/faq`
  }

  const handleLogoAspectRatio: ReactEventHandler<HTMLImageElement> = (e) => {
    const { naturalWidth, naturalHeight } = e.target as HTMLImageElement
    const ratio = naturalWidth / naturalHeight
    if (ratio > 1.5) {
      setLogoClasses('wide-iceberg')
    } else if (ratio < 0.75) {
      setLogoClasses('tall')
    } else {
      setLogoClasses('')
    }
  }

  return (
    <header className="header" style={{ background: 'white' }}>
      <div className="wrap">
        <figure className="logo">
          <img
            id="logo-img"
            className={logoClasses}
            src={`${import.meta.env.VITE_BLOB_STORAGE_URL}/${currentMerchantId}.png}`}
            onLoad={handleLogoAspectRatio}
            onError={(e) => {
              e.currentTarget.onerror = null
              e.currentTarget.src = `/images/iceberg.svg`
            }}
            alt="Iceberg Finance Logo"
          />
        </figure>
        <div className="right">
          <a href={needToHelpUrl} target="_blank" className="btn-simple" rel="noreferrer">
            {t('common.needHelp')}
          </a>
          <a href={faqLink()} target="_blank" className="btn-simple" rel="noreferrer">
            {t('common.FAQ')}
          </a>
          <button type="button" className="btn btn-blue" onClick={() => i18n.changeLanguage(targetLanguage)}>
            {targetLanguage}
          </button>
        </div>
      </div>
    </header>
  )
}

export default memo(Header)
